import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { TranslocoService, translate } from '@jsverse/transloco';
import { DropdownObject } from '@inmoment/the-kitchen';

import { ProjectCollection } from 'app/modules/project/models/project-collection.model';
import { FieldStatisticsPayload } from 'app/providers/field-statistics.service';
import { CalculationRequest } from 'app/providers/storage-api/predictive.service';
import { DriverAnalysisStep } from '../driver-analysis-dialog.component';
import { WidgetDriverAnalysisCreateOptions } from '../../project-collection-actions/project-collection-actions.component';

@Component({
  selector: 'app-weight-step',
  templateUrl: 'weight-step.component.html',
  styleUrls: ['./weight-step.component.scss'],
  standalone: false,
})
export class WeightStepComponent implements DriverAnalysisStep, OnInit {
  @Input() data: Partial<CalculationRequest>;
  @Input() collection: ProjectCollection;
  @Input() fieldStatisticsPayload: FieldStatisticsPayload;
  @Input() widgetData: WidgetDriverAnalysisCreateOptions;

  @Output() onValidityChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  isLoading: boolean;

  availableFields: DropdownObject[] = [
    {
      id: 'null',
      title: translate('driver-analysis-dialog.weight-step.no-weighting'),
    },
  ];
  selectedField = 'null';

  constructor(private translocoService: TranslocoService) {}

  ngOnInit(): void {
    this.onValidityChange.emit(true);

    if (this.collection.analyses[0].unAliasedWeightFields?.length) {
      for (const field of this.collection.analyses[0].unAliasedWeightFields) {
        if (field.metadata?.display !== false) {
          this.availableFields.push({ id: field.fieldName, title: field.displayName });
        }
      }
    }

    this.selectedField = this.data.properties.weightField ?? 'null';
  }

  onWeightChanged($event?: CustomEvent) {
    const fieldName: string = $event.detail?.id || $event.detail?.selected?.id;
    this.selectedField = fieldName;
    delete this.data.properties.weightField;

    if (fieldName !== 'null') {
      this.data.properties.weightField = fieldName;
    }
  }
}
